var _filter, _g, _text, _text2, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoHorizontal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 70,
    viewBox: "0 0 250 70",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logoGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1e40af",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#3b82f6",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "logoShadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 2,
    stdDeviation: 4,
    floodOpacity: 0.15
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10, 10)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 23,
    fill: "url(#logoGrad)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 20,
    fill: "url(#logoGrad)",
    filter: "url(#logoShadow)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25, 25)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -7,
    cy: -4,
    r: 3.5,
    fill: "white",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -10.5 6 Q -10.5 3 -7 3 Q -3.5 3 -3.5 6",
    stroke: "white",
    strokeWidth: 1.3,
    fill: "none",
    strokeLinecap: "round",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -5,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -4.5 7 Q -4.5 3 0 3 Q 4.5 3 4.5 7",
    stroke: "white",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: -4,
    r: 3.5,
    fill: "white",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.5 6 Q 3.5 3 7 3 Q 10.5 3 10.5 6",
    stroke: "white",
    strokeWidth: 1.3,
    fill: "none",
    strokeLinecap: "round",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("line", {
    x1: -3.5,
    y1: 6,
    x2: 0,
    y2: 6,
    stroke: "#10b981",
    strokeWidth: 1,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 6,
    x2: 3.5,
    y2: 6,
    stroke: "#10b981",
    strokeWidth: 1,
    opacity: 0.8
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 35,
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif",
    fontSize: 28,
    fontWeight: 700,
    fill: "#1e40af",
    letterSpacing: "-1px"
  }, "Vetana")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 55,
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif",
    fontSize: 28,
    fontWeight: 700,
    fill: "#059669",
    letterSpacing: "-1px"
  }, "HR")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 68,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 9,
    fontWeight: 500,
    fill: "#6b7280",
    letterSpacing: "1px"
  }, "HUMAN RESOURCES MANAGEMENT SYSTEM")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHorizontal);
export default __webpack_public_path__ + "static/media/logo-horizontal.910d9ea20ba73111ef320236e3586cae.svg";
export { ForwardRef as ReactComponent };